

























// Copyright © 2021 Move Closer

import { defineComponent, SetupContext } from '@vue/composition-api'

import { DashmixBox } from '../../atoms/Box'
import { DashmixButton } from '../../atoms/Button'
import { DashmixIcon, DashmixIconName } from '../../atoms/Icon'
import { DashmixInput } from '../../atoms/Input'
import { DashmixModal } from '../Modal'
import { DashmixSelect } from '../../atoms/Select'

import { DashmixTableSearchBarProps } from './TableSearchBar.contracts'
import { dashmixTableSearchBarProps, useDashmixTableSearchBar } from './TableSearchBar.hooks'

/**
 * @author Jan Dobrowolski <jan.dobrowolski@movecloser.pl>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const DashmixTableSearchBar = defineComponent({
  name: 'DashmixTableSearchBar',
  components: { DashmixBox, DashmixButton, DashmixIcon, DashmixInput, DashmixModal, DashmixSelect },
  props: dashmixTableSearchBarProps,

  setup (props: DashmixTableSearchBarProps, ctx: SetupContext) {
    return { ...useDashmixTableSearchBar(props, ctx), DashmixIconName }
  },
  emits: ['bulk']
})

export default DashmixTableSearchBar
